import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideIcons } from '@ng-icons/core';
import {
  tablerAdjustments, tablerAdjustmentsAlt, tablerAlertHexagon, tablerAlertOctagon, tablerAlertTriangle, tablerArrowLeft, tablerArrowNarrowLeft, tablerArrowRight, tablerArrowRightBar, tablerAsterisk, tablerBell, tablerBook2, tablerBuildingHospital, tablerCalendar, tablerCheck, tablerCheckbox, tablerChevronLeft,
  tablerChevronRight, tablerClock, tablerCopy, tablerDeviceAirpodsCase, tablerDownload, tablerEye, tablerEyeOff, tablerFingerprint, tablerFoldDown, tablerFoldUp, tablerGripHorizontal, tablerInfoCircle, tablerLink, tablerLoader, tablerLoader2, tablerLoaderQuarter, tablerMapPin, tablerMessage, tablerMoon, tablerPencil, tablerPhoto, tablerPill, tablerPlus, tablerSearch, tablerStethoscope, tablerSun, tablerTrash,
  tablerUser,
  tablerX
} from '@ng-icons/tabler-icons';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AutoRefreshTokenService, includeBearerTokenInterceptor, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { provideKeycloakAngular } from './keycloak.config';

registerLocaleData(localeEs, 'es');

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, '/assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    // provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    })]),
    provideIcons({
      tablerBell, tablerLink, tablerPill, tablerAlertOctagon, tablerArrowLeft, tablerArrowRight, tablerPencil, tablerTrash, tablerPlus, tablerDeviceAirpodsCase,
      tablerBuildingHospital, tablerChevronLeft, tablerChevronRight, tablerAdjustments, tablerAlertTriangle, tablerX, tablerCheck, tablerLoader2, tablerLoaderQuarter,
      tablerLoader, tablerSearch, tablerInfoCircle, tablerDownload, tablerAsterisk, tablerArrowRightBar, tablerEye, tablerEyeOff, tablerFoldDown, tablerFoldUp,
      tablerFingerprint, tablerCalendar, tablerAdjustmentsAlt, tablerClock, tablerMapPin, tablerAlertHexagon, tablerUser, tablerMessage, tablerStethoscope, tablerCheckbox,
      tablerArrowNarrowLeft, tablerCopy, tablerGripHorizontal, tablerBook2, tablerPhoto, tablerSun, tablerMoon
    }),
    provideAnimationsAsync(),
    provideAnimations(),
    BrowserAnimationsModule,
    importProvidersFrom(
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    )
  ]
};
